import React from 'react';
import AdminKnowledgeBasePage from '../components/AdminKnowledgeBase/AdminKnowledgeBasePage';

const AdminKnowledgeBase = () => <AdminKnowledgeBasePage />;

export default AdminKnowledgeBase;
